'use client'

import { useEffect } from 'react'
import { initStickyYear, updateStickyYearOnScroll } from '../utils/stickyYear.utils'
import useCurrentLocale from '../../../../core/hook/useCurrentLocale'
import { getIsArabicLocale } from '../../../utils/locale.utils'

const StickyYearOnBlogList = ({ isReady }: { isReady: boolean }) => {
  const currentLocale = useCurrentLocale()
  const isArabicStore = getIsArabicLocale(currentLocale)

  useEffect(() => {
    if (!isReady) {
      return
    }

    initStickyYear()

    const sticky = () => updateStickyYearOnScroll(isArabicStore)

    window.addEventListener('scroll', sticky)

    return () => {
      window.removeEventListener('scroll', sticky)
    }
  }, [isReady])

  return <div className='Sticky-year' />
}

export default StickyYearOnBlogList
